import { VIEW_PRESET_KEYS, VIEW_PRESET_LABELS, type ViewPresetKey } from '@/lib/views/presets'

export function PresetSwitcher({
  value,
  onChange,
}: {
  value: ViewPresetKey
  onChange: (value: ViewPresetKey) => void
}) {
  return (
    <div role="tablist" aria-label="Представление склада" className="flex rounded-full border border-rule bg-paper p-1">
      {VIEW_PRESET_KEYS.map((key) => (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={value === key}
          onClick={() => onChange(key)}
          className={`rounded-full px-3 py-1.5 text-xs font-medium ${value === key ? 'bg-ink text-white' : 'text-ink-2 hover:bg-bone/60'}`}
        >
          {VIEW_PRESET_LABELS[key]}
        </button>
      ))}
    </div>
  )
}
